export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14683.94a98b44.jpg";